export default __webpack_public_path__ + "static/media/Fedor-Holz.812b7228.png";